import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../../../Common/DataTable';
import { RootState } from '../../../../redux/rootState';
import { setLoader } from '../../../../redux/loaderSlice';
import ComponentDeleteModal from '../../../../Common/DeleteModal/ComponentDeleteModal';
import ComponentDefectCodeDialog from './ComponentDefectCodeDialog';
import { deleteDefectCodeListStart, getDefectCodeListStart } from '../redux/sliceDefectCodeList';
import { DefectCodeList } from '../utils/types';

function ComponentDefectCodeListTable() {
  const [open, setOpen] = useState(false);
  const [rowId, setRowId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDefectCodeListId, setSelectedDefectCodeListId] = useState<string>('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const dispatch = useDispatch();

  const { isLoading, DefectCodeListData } = useSelector((state: RootState) => state.ListDefectCodeReducer);
  const { showDeleteIcon } = useSelector((state: RootState) => state.masterDataReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(getDefectCodeListStart(params));
  };

  const handleAction = (id: string) => {
    setOpen(true);
    setRowId(id);
  };

  const handleButtonClick = () => {
    setRowId('');
    setOpen(!open);
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const TableColumns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'code', label: 'Code' },
      { key: 'category', label: 'Category' },
      { key: 'sub_category', label: 'Sub-Category' },
      { key: 'color', label: 'Color' },
      { key: 'description', label: 'Description' },
    ],
    [],
  );

  const tableData: DefectCodeList[] = useMemo(() => DefectCodeListData?.Data?.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      action: showDeleteIcon ? 'edit&delete' : 'edit',
      code: item?.Code,
      category: item?.Category,
      sub_category: item?.SubCategory,
      color: item?.Color,
      description: item?.Description,
      id: String(item?.Id),
    };
    return transformedDataItem;
  }), [DefectCodeListData]);

  const handleDelete = (id: string) => {
    setShowDeleteModal(true);
    setSelectedDefectCodeListId(id);
  };

  const handelDeleteModal = () => {
    const paramData = {
      Id: selectedDefectCodeListId,
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(deleteDefectCodeListStart(paramData));
    setShowDeleteModal(false);
  };

  return (
    <>
      <DataTable<DefectCodeList>
        handleButtonClick={handleButtonClick}
        data={tableData}
        columns={TableColumns}
        totalRecords={DefectCodeListData?.TotalRecords}
        buttonText="Add"
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleData={handleData}
        handleEdit={handleAction}
        handleDelete={handleDelete}
      />
      <ComponentDefectCodeDialog show={open} setOpenFrom={handleButtonClick} rowId={rowId} handleData={handleData} />
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setShowDeleteModal(false)}
        handleDelete={handelDeleteModal}
      />
    </>
  );
}

export default ComponentDefectCodeListTable;
